<template>
  <div class="p-2 sm:p-4">
    <div class='flex justify-between items-center'>
      <div>
        <h1>Sale Order</h1>
      </div>
      <div class="flex flex-col text-right justify-end">
      </div>
    </div>
    <div class="hr"></div>
    <tabs>
      <tab :selected="true" name="Sale Order">
        <div class="my-5 flex justify-end space-x-3">
          <template v-if="saleOrder.length">
            <button class="btn-sm btn-green" @click="saveSaleOrder">Save Sale Order</button>
            <button class="btn-xs btn-red-outline" @click="refreshSaleOrderData">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
              </svg>
            </button>
            <button class="btn-link p-1 border border-transparent hover:border-blue-800 rounded-md"  @click="$refs.downloadData.exportCSVFile(`${event.name}_sale_order`,saleOrder, saleOrderHeaders)">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9.75v6.75m0 0l-3-3m3 3l3-3m-8.25 6a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z" />
              </svg>
            </button>
          </template>
          <button v-else class="btn-sm btn-blue" @click="getSaleOrderData(false)">Load Sale Order</button>
        </div>
        <h3>Additional Fields</h3>
        <div class="flex space-x-3 mt-1 border-t pt-1">
          <div v-for="(f, i) in Object.keys(fields)" :key="i" class="relative flex items-start">
            <div class="flex h-5 items-center">
              <input v-model="fields[f]" id="comments" aria-describedby="comments-description" name="comments" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500">
            </div>
            <div class="ml-1 text-sm">
              <label for="comments" class="font-medium text-gray-700">{{f}}</label>
            </div>
          </div>
        </div>
        <showman-table class="mt-4" :tableData="saleOrder" :tableFields="saleFields" :condensed="true" @orderUpdated="saleOrderUpdated" :allowDraggable="true">
          <div slot=" " slot-scope="data" class="">
            <div class="">
              <button class="btn-link" @click="deleteItem(data.item)">X</button>
            </div>
          </div>
        </showman-table>
      </tab>
      <tab name="Settings" v-if="currentUser.user_id === 'Clo1Va5v4pNuvE1TqHPNeKWFGay2'">
         <div class="my-2 flex justify-end space-x-3">
          <button class="btn btn-blue" @click="updateEvent">Save Settings</button>
        </div>
        <v-jsoneditor v-model="adminData.event.event_settings.sale_order_settings" :options="{mode:'code'}" :plus="false" height="700px" class="mb-4"/>
      </tab>
    </tabs>
    <DownloadData ref="downloadData"/>

  </div>
</template>

<script>
import VJsoneditor from 'v-jsoneditor'
import DownloadData from '@/components/DownloadData'
import Vue from 'vue'

export default {
  components: {
    VJsoneditor,
    DownloadData
  },
  data () {
    return {
      saleOrder: [],
      fields: {},
      sale_order_id: null
    }
  },
  methods: {
    getSaleOrderData (forceRefresh) {
      this.axios.get(`${process.env.VUE_APP_ROOT_API}/saleOrder/getSaleOrder?event_id=${this.adminData.event.event_id}&refersh=${forceRefresh}`)
        .then(response => {
          this.saleOrder = response.data.data.saleOrder
          this.sale_order_id = response.data.data.sale_order_id
          this.setFields()
        })
    },
    refreshSaleOrderData () {
      this.notie.confirm({
        text: `Are you sure you want to refresh sale order? This will reset any changes you have already made?`,
        submitCallback: () => {
          this.getSaleOrderData(true)
        }
      })
    },
    updateEvent () {
      this.$store.dispatch('updateEvent', this.event)
        .then(response => {
          this.notie.alert({
            type: 1,
            text: `Event, ${this.event.name} Successfully Updated`
          })
        })
        .catch(() => {
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `Error updating event, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },
    setFields () {
      this.possibleFields.forEach(f => {
        Vue.set(this.fields, f, false)
      })
    },
    saleOrderUpdated (value) {
      this.saleOrder = value
    },
    deleteItem (item) {
      this.notie.confirm({
        text: `Are you sure you want to delete this item?<br>${item.placing_text} - ${item.first_name} ${item.last_name}`,
        submitCallback: () => {
          this.saleOrder.splice(this.saleOrder.indexOf(item), 1)
        }
      })
    },
    saveSaleOrder () {
      if (this.sale_order_id) {
        this.$store.state.apiInstance.put(`/data/saleOrders/${this.sale_order_id}`, {sale_order_data: this.saleOrder})
      } else {
        this.$store.state.apiInstance.post('/data/saleOrders', {sale_order_data: this.saleOrder, created_by: '1', event_id: this.event.event_id})
          .then(result => {
            this.sale_order_id = result.data.data.sale_order_id
          })
      }
    }
  },
  computed: {
    currentUser () {
      return this.$store.state.user
    },
    adminData () {
      return this.$store.state.admin.adminData
    },
    event () {
      return this.adminData.event
    },
    possibleFields () {
      let fields = new Set()
      this.saleOrder.forEach(so => {
        Object.keys(so.entry_details).forEach(ef => {
          if (ef !== 'exhibitor' && ef !== 'place' && ef !== 'division') {
            fields.add(ef)
          }
        })
      })
      return fields
    },
    saleFields () {
      let fields = [

        {key: 'order', position: 'left'},
        {key: 'placing_text', position: 'left'},
        {key: 'exhibitor_number', position: ''},
        {key: 'first_name', position: 'left'},
        {key: 'last_name', position: 'left'}
      ]
      Object.keys(this.fields).forEach(f => {
        if (this.fields[f]) {
          fields.push({
            key: f
          })
        }
      })
      fields.push({
        key: ' '
      })
      return fields
    },
    saleOrderHeaders () {
      let headers = []
      this.saleFields.forEach(f => {
        headers.push({
          field: f.key,
          header: f.key
        })
      })
      return headers
    }
  }
}
</script>

<style>

</style>
